export default __webpack_public_path__ + "static/media/uploadIcon.840d8354.png";